export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const HOURS = Array.from({ length: 24 }, (_, i) => i);

export function fmtHour(h) {
  return `${String(h).padStart(2, "0")}:00`;
}

export function fmtRange(h) {
  return `${fmtHour(h)}–${fmtHour((h + 1) % 24)}`;
}

export function cellKey(siteId, day, hour) {
  return `${siteId}|${day}|${hour}`;
}
